import { datetime } from '~/tools/datetime';

/**
 * Transform a conversation returned by server to usable format by front-end UI.
 *
 * @example conversation (from server)
 *  {
 *    "id": 123,
 *    "created": "1024809182409",
 *    "surveyId": 123,
 *    "surveyName": "Klaus' Survey",
 *    "reactedLike": true,
 *    "reactedGreatIdea": false,
 *    "reactedWorkingOnIt": false,
 *    "response": {
 *      "id": 456,
 *      "title": "Question title?",
 *      "comment": "Employee response",
 *      "__typename": "ConversationResponse"
 *    },
 *    "__typename": "ConversationsListItem"
 *  }
 */
const conversationFrom = (conversation) => {
  return {
    id: conversation.id,
    text: conversation.response.comment,
    created: datetime.fullDateFormat(conversation.created),
    surveyId: conversation.surveyId,
    surveyName: conversation.surveyName,
    responseId: conversation?.response?.id,
    questionTitle: conversation?.response?.title,
    reactedLike: conversation.reactedLike,
    reactedGreatIdea: conversation.reactedGreatIdea,
    reactedWorkingOnIt: conversation.reactedWorkingOnIt,
    messages: [],
  };
};

/**
 * Transform a conversation message returned by server to usable format by front-end UI.
 *
 * @example conversation message (from server)
 *  {
 *    "id": 123, // or null
 *    "text": "My comment",
 *    "conversationId": 456,
 *    "created": "1561132576000",
 *    "user": null,
 *    "__typename": "MinimalConversationMessage"
 *  }
 */
const conversationMessageFrom = (message) => {
  const user = !message.user
    ? null
    : {
        id: message.user.id,
        name: `${message.user.firstName} ${message.user.lastName}`,
        avatarURL: message.user.avatar,
      };

  return {
    id: message.id,
    text: message.text,
    created: datetime.fullDateFormat(message.created),
    user,
    conversationId: message.conversationId,
  };
};

/**
 * Transform a conversation reaction returned by server to usable format by front-end UI.
 *
 * @example conversation reaction (from server)
 *  {
 *    "like": true,
 *    "greatIdea": false,
 *    "workingOnIt": false,
 *    "conversation": {
 *      "id": 123,
 *      "__typename": "Conversation"
 *    },
 *    "__typename": "ConversationReaction"
 *  }
 */
const conversationReactionFrom = (conversationReaction) => {
  return {
    like: conversationReaction?.like,
    greatIdea: conversationReaction?.greatIdea,
    workingOnIt: conversationReaction?.workingOnIt,
    conversationId: conversationReaction?.conversation?.id,
  };
};

export { conversationFrom, conversationMessageFrom, conversationReactionFrom };
